module.exports = __webpack_public_path__ + "static/img/thankyou-share.874be7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thankyou-share.png
// module id = 345
// module chunks = 0